import PropTypes from 'prop-types';
import {
    Avatar,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { useState } from 'react';
import Iconify from 'src/components/iconify';

export default function Members({ selectedMembers, onChange, memberOptions }) {
    const [ open, setOpen ] = useState(false);

    const toggleDialog = () => setOpen(prev => !prev);

    const handleMemberToggle = (memberId) => {
        const updated = selectedMembers.includes(memberId)
            ? selectedMembers.filter((id) => id !== memberId)
            : [ ...selectedMembers, memberId ];
        onChange(updated);
    };

    const renderMemberSection = (title, members) => (
        <>
            <Typography variant="subtitle2" sx={ { mb: 1, mt: 2 } }>{ title }</Typography>
            <List sx={ { pt: 0 } }>
                { members.map((member) => (
                    <ListItem
                        key={ member.id }
                        dense
                        disablePadding
                        sx={ { mb: 1 } }
                    >
                        <Avatar sx={ { bgcolor: member.color, mr: 1 } }>{ member.id }</Avatar>
                        <ListItemText primary={ member.name } />
                        <IconButton
                            size="small"
                            onClick={ () => handleMemberToggle(member.id) }
                        >
                            <Iconify icon={ selectedMembers.includes(member.id) ? "mdi:close" : "mdi:plus" } />
                        </IconButton>
                    </ListItem>
                )) }
            </List>
        </>
    );

    return (
        <Stack direction="row" sx={ { mb: 2 } }>
            <Stack direction="row" spacing={ 1 } alignItems="center">
                { selectedMembers.map((id) => {
                    const member = memberOptions.find((m) => m.id === id);
                    return (
                        <Avatar
                            key={ id }
                            sx={ {
                                bgcolor: member?.color || '#9e9e9e',
                                width: 30,
                                height: 30,
                                fontSize: 14
                            } }
                        >
                            { id }
                        </Avatar>
                    );
                }) }
                <IconButton size="small" onClick={ toggleDialog }>
                    <Iconify icon="mdi:plus" />
                </IconButton>
            </Stack>

            <Dialog
                open={ open }
                onClose={ toggleDialog }
                PaperProps={ { sx: { width: 300, maxWidth: '100%' } } }
            >
                <DialogTitle>
                    Members
                    <IconButton
                        onClick={ toggleDialog }
                        sx={ { position: 'absolute', right: 8, top: 8 } }
                    >
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={ { p: 2 } }>
                    <TextField
                        fullWidth
                        placeholder="Search members"
                        variant="outlined"
                        sx={ { mb: 2 } }
                        InputProps={ {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon="mdi:magnify" />
                                </InputAdornment>
                            )
                        } }
                    />
                    { renderMemberSection('Card members', memberOptions.slice(0, 2)) }
                    { renderMemberSection('Board members', memberOptions.slice(2, 7)) }
                    { renderMemberSection('Workspace members', memberOptions.slice(7)) }
                </DialogContent>
            </Dialog>
        </Stack>
    );
}

Members.propTypes = {
    selectedMembers: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    memberOptions: PropTypes.array.isRequired
};
